import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NeighborhoodService } from 'src/app/service/Neighborhood.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { Neighborhood } from './neighborhood';
import { Router } from '@angular/router';

@Component({
  selector: 'app-neighborhood',
  templateUrl: './neighborhood.component.html',
  styleUrls: ['./neighborhood.component.scss']
})
export class NeighborhoodComponent implements OnInit {

  

  formulario: FormGroup;
  neighborhoods: Neighborhood[] = [];
  //ordem das colunas no html 
  ordemColunasTabela = ['id', 'name','excluir','editar'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100]; // [10,20,30] quantidade de item por página
  mensagemErros: String[] = []; //array de strings dos erros retornados do backend  
  tipoFiltros: String[] = ['Nome'];    
  tipoFiltro: any;
  parametroConsulta: any;

  constructor(
    private neighborhoodService: NeighborhoodService,
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    this.listarNeighborhoodService(this.pagina, this.tamanho);
  }

  submit() {
    //pegar os dados do formulário
    const formValues = this.formulario.value;
    // cria e adiciona no objeto
    const neighborhood: Neighborhood = new Neighborhood(
      formValues.id,
      formValues.name,
      );

    if (formValues.id) {
      this.neighborhoodService.update(neighborhood).subscribe(resposta => {
        this.listarNeighborhoodService(this.pagina, this.tamanho);
        // exibir mensagem snackbar
        this.snackBar.open('Produto alterado com sucesso!', 'Sucesso', {
          duration: 2000
        })
        //limpar formulário
        this.formulario.reset();
      }, errorResponse => {
        // exibir mensagem snackbar
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000
        })
      })
    } else {
      // cria e adiciona no objeto
      this.neighborhoodService.save(neighborhood).subscribe(resposta => {
        this.listarNeighborhoodService(this.pagina, this.tamanho);
        // exibir mensagem snackbar
        this.snackBar.open('Bairro salvo com sucesso!', 'Sucesso', {
          duration: 2000
        })
        //limpar formulário
        this.formulario.reset();
      }, errorResponse => {
        // exibir mensagem snackbar
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000
        })
      })
    }
  }

  montarFormulario() {
    this.formulario = this.formBilder.group({
      id: [null, Validators.nullValidator],
      name: [null, [Validators.minLength(3), Validators.maxLength(250)]]
    })
    this.tipoFiltro = "Nome";
  }

  limparFormulario() {
    this.formulario.reset();    
  }

  consultar(){
    
    if(this.parametroConsulta ==  null){
      this.parametroConsulta = '%%'
    }    
    this.neighborhoodService.findNeighborhood(this.pagina, this.tamanho,this.parametroConsulta).subscribe((response) => {
      this.neighborhoods = response.content; // pegar o conteudo do pag
      this.totalElementos = response.totalElements;// pegar o total de elementos
      this.pagina = response.number;// pegar o numero de paginas
    });
  }

  listarNeighborhoodService(pagina: number, tamanho: number) {// definir a primeira página e o tamanho inicial
    this.neighborhoodService.list(pagina, tamanho).subscribe((response) => {
      this.neighborhoods = response.content; // pegar o conteudo do pag
      this.totalElementos = response.totalElements;// pegar o total de elementos
      this.pagina = response.number;// pegar o numero de paginas
    });
  }

  private excluir(id: number) {
    this.neighborhoodService.delete(id).subscribe((response) => {
      this.ngOnInit();
      this.mensagemErros = [];
      // exibir mensagem snackbar
      this.snackBar.open('Bairro excluido com sucesso!', 'Sucesso', {
        duration: 2000
      })
    }, errorResponse => {
      // exibe mensagem de erro da api
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    })
  }

  editar(id: number) {
    this.neighborhoodService.findNeighborhoodById(id).subscribe((response) => {
      // cria e adiciona no objeto
      this.formulario.controls.id.setValue(id);
      this.formulario.controls.name.setValue(response.name);
    })
  }

  //chamar a paginação
  paginar(event: PageEvent) {
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.listarNeighborhoodService(this.pagina, this.tamanho);
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      // se clicar em ok chama evento de excluir
      if (result) {
        this.excluir(id);
      }
    });
  }

}
